import type { ButtonHTMLAttributes, ReactNode } from 'react';

/**
 * The three button roles of the design system, ported from the prototype.
 * `ButtonPrimary` is the singular commit action of a screen (coral, with the
 * postage-stamp shadow); `ButtonDark` is the secondary solid; `QuietButton`
 * is the low-emphasis utility action. Anything that commits a card without
 * an explicit photo choice must stay disabled — that law is enforced by the
 * flows, these components just render the state honestly.
 */

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { children: ReactNode };

export function ButtonPrimary({ className = '', ...props }: ButtonProps) {
  return <button type="button" className={`rd-button-primary ${className}`.trim()} {...props} />;
}

export function ButtonDark({ className = '', ...props }: ButtonProps) {
  return <button type="button" className={`rd-button-dark ${className}`.trim()} {...props} />;
}

export function QuietButton({ className = '', ...props }: ButtonProps) {
  return <button type="button" className={`rd-button-quiet ${className}`.trim()} {...props} />;
}
